import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsHaveibeenpwnedComponent } from './simple-icons-haveibeenpwned.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsHaveibeenpwnedComponent ],
    exports:      [ SimpleIconsHaveibeenpwnedComponent ],
    bootstrap:    []
})
export class SimpleIconsHaveibeenpwnedModule {}
